import {useEffect, useRef, useState} from 'react';
import '../assets/css/ErrorMessage.css'; // Import your CSS styles here
import PropTypes from 'prop-types';

const ErrorMessage = ({isVisible, message, onClose}) => {
  const [show, setShow] = useState(isVisible);
  const closeRef = useRef(null);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
    } else {
      const timer = setTimeout(() => setShow(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  // Move focus into the dialog when it opens and let Escape dismiss it.
  useEffect(() => {
    if (!isVisible) return undefined;
    if (closeRef.current) closeRef.current.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isVisible, onClose]);

  if (!show) return null;

  const handleOverlayClick = () => {
    onClose(); // Close the modal when clicking on the overlay
  };

  return (
    <div className={`error-overlay ${isVisible ? '' : 'hide'}`} onClick={handleOverlayClick}>
      <div
        className="error-content"
        role="alertdialog"
        aria-modal="true"
        aria-label="Error"
        aria-describedby="error-message-text"
        onClick={(e) => e.stopPropagation()}
      >
        <p id="error-message-text" style={{whiteSpace: 'pre-line'}}>
          {message}
        </p>
        <button
          ref={closeRef}
          type="button"
          className="btn btn-secondary error-close"
          onClick={handleOverlayClick}
        >
          Close
        </button>
      </div>
    </div>
  );
};

// Define prop types
ErrorMessage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ErrorMessage;
